import { _axios } from "../../../Utils/Axios/axios";

export const getRandomAdService = async (userToken: string) => {
  return _axios.post(
    "/get_random_advertise",
    {},
    {
      headers: {
        Authorization: `Bearer ${userToken}`,
      },
    }
  );
};
